export function strToBoolean(a_string){
    if(a_string == "true"){return true;}
    else{return false;}
}
export function replaceAll(search, replacement, target) {
    return target.split(search).join(replacement);
};
export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}